$(document).ready(function (e){

// Corregir precio m2 desde metafield después de render de Boost SD
function fixMetafieldPrices() {
  if (
    !window.feltrexData ||
    !window.feltrexData.medida2 ||
    !window.feltrexData.medida2.length
  ) return;

  document.querySelectorAll('.thumbnail').forEach(function(card) {
    var match = card.className.match(/\bproduct-(\d+)\b/);
    if (!match) return;

    var productId = parseInt(match[1], 10);

    var meta = window.feltrexData.medida2.find(function(m) {
      return parseInt(m.id, 10) === productId;
    });

    if (!meta || !meta.valor_m) return;

    var moneyEl = card.querySelector('.current_price .money');
    if (!moneyEl) return;

    var valor = parseFloat(String(meta.valor_m).replace(',', '.'));
    if (isNaN(valor)) return;

    var valorFormateado = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    }).format(valor);

    moneyEl.innerHTML = valorFormateado;
    
    var priceContainer = card.querySelector('.current_price');
    if (priceContainer && !priceContainer.innerHTML.includes('Valor m2:')) {
      priceContainer.innerHTML = 'Valor m2: <span class="money">' + valorFormateado + '</span>';
    }
  });
}

  fixMetafieldPrices();



 //console.log('custom.js');

    /* [ BOLETA O FACTURA */
  
 /*  document.querySelector('#dte').addEventListener('change',function(){
    if(this.value == 'Factura'){
      document.querySelector('#rutempresa').attributes.required = 'true';
      $('#label-rut').innerHTML = 'Rut Empresa';
    }else{
      document.querySelector('#rutempresa').attributes.required = 'false';
      $('#label-rut').innerHTML = 'Rut Cliente';
    }
  }); */

  /*AGREGA REQUIRED A CAMPOS DE FACTURA*/
  $('#cart_form #dte').on('change', function() {
     if($(this).val() == 'Factura'){
       //$('#rutempresa').attr("required", true);
       $('#razonsocial').attr("required", true);
       $('#giro').attr("required", true);
       $('#label-rut').text('Rut Empresa');
     }else{
       /* $('#rutempresa').attr("required", false); */
       $('#razonsocial').attr("required", false);
       $('#giro').attr("required", false);
       $('#label-rut').text('Rut Cliente');
     };
  });


    /*MENSAJE INVALID*/
  $('#cart_form input[type=text]').on('change invalid', function() {
      var campotexto = $(this).get(0);
      campotexto.setCustomValidity('');
  
      if (!campotexto.validity.valid) {
        campotexto.setCustomValidity('Campo obligatorio!');  
      }
  });
 
 
  
     
  console.log('slider-custom', $('.slider-custom'));
  console.log('slider-custom a', $('.slider-custom a'));
  if($('.slider-custom').length > 0){
    $('.slider-custom').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: `<button class="slick-prev" aria-label="Previous" type="button">
<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="15.5" cy="15.5" r="15" stroke="#878787"/>
<path d="M17.5 10L12.7071 14.7929C12.3166 15.1834 12.3166 15.8166 12.7071 16.2071L17.5 21" stroke="#878787" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</button>`,
    nextArrow: `<button class="slick-next" aria-label="Next" type="button">
<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="15.5" cy="15.5" r="15" transform="rotate(-180 15.5 15.5)" stroke="#878787"/>
<path d="M13.5 21L18.2929 16.2071C18.6834 15.8166 18.6834 15.1834 18.2929 14.7929L13.5 10" stroke="#878787" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</button>`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  }

  if($('.slider-custom-2').length > 0){
    $('.slider-custom-2').slick({
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  });
  }

  if($('.collection-sub--slider').length > 0){
    $('.collection-sub--slider').slick({
    autoplay: false,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  }

  if($('.accordion-item__header').length > 0){
      $(".accordion-item__header").on('click',function(e){
      e.preventDefault();
      $(this).children ("span").toggleClass("icon-arrow-active");
      $(this).next(".accordion-item__collapse").slideToggle();
    });
  }
 
  
  /* DETECTA CUANDO SE CARGA EL SLIDER DE VISTOS RECIENTES*/
  
  // Funcion que detecta que se cargo un elemento creado por js
  var wait = (e, funct) => {
      var r = setInterval(() => {
          if(document.querySelector(e)) { 
          	if(document.querySelector(e).clientHeight > 30) {
                clearInterval(r);
                funct();
            }
          }
      }, 100);
  };
                  

  // Funcion que agrega el alto a las cards, una vez que slider cargo
  wait('.product-list-custom', slider); 
  function slider(){
    let cards = document.querySelectorAll('.product-list-custom  .gallery-cell');
   
    for(let card of cards) {
    	card.style.height = '100%';
    }

    colorVariaton();
  }

  


  /* Variacion de imagen  */
   function colorVariaton(){
      const list = document.querySelectorAll(".swatch > span[data-image]");
      ////console.log({list});
      for (var i = 0; i < list.length; i++) {
        var url = list[i].getAttribute('data-image');
        //////console.log({url});
        list[i].style.backgroundImage="url('" + url + "')";
      }
    } 


  /*EVENTO DE RECARGAR PAGINA AL PRECIONAR BOTON DE APP DE CALCULOS*/
  wait('.addToCartCustomButton', carculatorReset);

  function carculatorReset(){
    let buttonsCarculator = document.querySelector('.addToCartCustomButton');
    buttonsCarculator.addEventListener('click', function(e) {
       //window.location.reload()
    });
  }

  let buttons = document.querySelectorAll('.thumbnail-overlay__button ');

  if(buttons){
      for(let button of buttons) {
        button.addEventListener('click', function(e) {
          //document.querySelector('.fancybox-container').clientHeight;
          wait('.fancybox-container', test);
        });
      }
    
  }

  function test(){
	let price = document.querySelector('.fancybox-container .modal_price').innerText;
          
    price.innerText = `${boostPFSThemeConfig.custom.metafields.medida} ${price}`;
  }


  
  
  
 /* CALCULO DE METROS CUADRADOS */
const inputCantidad = document.querySelector('.shopify-product-form .quantity');
const inputPrecio = document.querySelector('.modal_price .money'); 
const inputCalculo = document.querySelector('#calculo'); 

const inputCantidadCart = document.querySelector('#cart_form .quantity');
const inputCalculoCart = document.querySelector('#calculo-cart');

// Nota: Asegúrate de que las variables 'cantidad' y 'medida' estén definidas antes de este bloque
if(inputCantidad && typeof cantidad !== 'undefined' && cantidad != 0){
  
  function htmlCalculo (){
    // 1. Eliminamos el signo de moneda y cualquier espacio
    let precioTexto = inputPrecio.innerHTML.replace(/[^\d.,]/g, '');
    
    // 2. Si el formato usa punto para miles y coma para decimales (ej: 51.696,00 o 51.696)
    // Reemplazamos el punto de los miles por nada, y la coma decimal por punto.
    // Si tu formato usa coma para miles (ej: 51,696), invierte los reemplazos.
  
     precioTexto = precioTexto.replace(',', '.').replace(/\./g, '');
    
    // 3. Convertimos a número decimal de manera segura
    const precio = parseFloat(precioTexto); 

    // 4. Calculamos el total multiplicando por la cantidad del input
    const totalDinero = precio * parseInt(inputCantidad.value, 10);
    const totalMetros = (parseFloat(cantidad) * parseInt(inputCantidad.value, 10)).toFixed(2);
    
    // 5. Formateamos el dinero de vuelta a un formato legible
    const dineroFormateado = new Intl.NumberFormat('es-CL', { 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 6 
    }).format(totalDinero);
    
    inputCalculo.innerHTML = `
      <div class="text-cantidad"> 
         $${dineroFormateado} equivale a ${totalMetros} ${medida} 
      </div>`;  
  }
  
  htmlCalculo();
  
  inputCantidad.onchange = function() {
    htmlCalculo();
  };
  
  // También es recomendable escuchar el evento 'input' por si escriben el número a mano
  inputCantidad.oninput = function() {
    htmlCalculo();
  };
}


  // RESETEA VALOR POR METRO CUADRADO QUE SALE EN PISOS
  const price_m = document.querySelector('.price-m');
  if(price_m){
    price_m.innerHTML = new Intl.NumberFormat().format(price_m.innerHTML);
    
  }
  
  
  /* TAB SE AGREAGA UN ACTIVE A CONTENT */ /*SECCION PRODUCTOS*/
  var tabbedContent = function(classTab, classContent) {
      //Obtiene todos los elementos del tab
      var tabs = document.getElementsByClassName(classTab);
      //Obtiene todos los elementos del contenido tab
      var tabsContents = document.getElementsByClassName(classContent);

      for(let tab of tabs) {
          //Agrega el click a al tab
          tab.addEventListener('click', function(e) {

              // Elimina todas las clases activas del tab
              for(let taball of tabs){
                  taball.classList.contains(`${classTab}--active`) ? 
                  taball.classList.remove(`${classTab}--active`) : null; 
              }

              // Elimina todas las clases activas del content tab
              for(let tabsContent of tabsContents){
                  tabsContent.classList.contains(`${classContent}--active`) ? 
                  tabsContent.classList.remove(`${classContent}--active`) : null;
              }

              //obtiene el atributo data-tab del elemento que se hizo click
              var matchingTab = this.getAttribute('data-tab');
              let idcontent = document.getElementById(matchingTab);

              // agrega o elimina el active al tab
              this.className += ` ${classTab}--active`;

              //agrega o elimina el active al content tab que corresponde
              idcontent.className += ` ${classContent}--active`;
            
            
          }, false);
      }
  }

  tabbedContent('item-tab', 'item-body'); // SECCION ARQUITECTOS
  
  
  
  /*FILTRO SUCURSALES*/
  let cardSucusal = [... document.querySelectorAll('.card-sucusal')]
  let boxsSucursal = document.querySelectorAll('.card-sucusal .card-custom__title');
  let inputfiltermap = document.querySelector('#filtermap');
  
  
  ////console.log('boxSucursal',[boxsSucursal]);
  
  if(inputfiltermap){
    const heightMap = document.querySelector(`#map-google iframe`).getAttribute('height');
    
    // Al usar el buscador
    inputfiltermap.addEventListener('keyup', function(e) { //Detecta cuando el se escribe en el input
      for(let box of boxsSucursal) {
        
        //Busca si el nombre de la sucursal existe segun lo que se escribio en el input
        var index = box.innerHTML.toUpperCase().indexOf(this.value.toUpperCase()); 

        // Esconde o muestra los elementos segun corresponde
        if(index >= 0) {
            box.parentNode.style.display = '';
        } else {
            // si index es 0 no encontro sucursal
            box.parentNode.style.display = 'none';
        }
        
      ////console.log('boxSucursal',this.value);
    
       }
      
       //const result = boxsSucursal.filter(element => element.innerHTML.toUpperCase().indexOf(this.value.toUpperCase()) >= 0);
      
       //Devuelve arreglo con las sucursales que coinciden con la buesqueda
       const result = Array.from(boxsSucursal).filter(element => element.innerHTML.toUpperCase().indexOf(this.value.toUpperCase()) >= 0);
      
       // Toma primer elemento del arreglo
       if(result[0]){
         let map = document.querySelector(`#map-google iframe`);
         
         //Recorre los hijos del elemento activo
         for (var i = 0; i < result[0].parentNode.childNodes.length; i++) {
              if (result[0].parentNode.childNodes[i].className == "address") {
                ////console.log('result[0]', result[0].parentNode.childNodes[i].getAttribute("data-address"));
         
                let address = result[0].parentNode.childNodes[i].getAttribute("data-address").replaceAll(' ', '+');
                
                // agrega iframe con la ubicacion 
                map.parentNode.innerHTML = `<iframe width="100%"  height="${heightMap}" id="test" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=${address}&amp;z=15&amp;output=embed"></iframe>`;
                break;
              }        
          }
         
       }else{
         //map.parentNode.innerHTML = map;
       }
       
    });
    
    
    //Al hacer click en la card muestra el mapa seleccionado
    for(let card of cardSucusal){
      
        card.addEventListener('click', function(event) {
         let map = document.querySelector(`#map-google iframe`);


         for (var i = 0; i < this.children.length; i++) {
           if (this.children[i].className == "address") {
             ////console.log('result[0]', result[0].parentNode.childNodes[i].getAttribute("data-address"));

             let address = this.children[i].getAttribute("data-address").replaceAll(' ', '+');

             // agrega iframe con la ubicacion 
             map.parentNode.innerHTML = `<iframe width="100%"  height="${heightMap}" id="test" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=${address}&amp;z=15&amp;output=embed"></iframe>`;
             break;
           }        
         }

      });
      
    }
    
    
  }



 

  
  
});